<template>
    <el-dialog
        class="report"
        :visible.sync="reportVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1000px"
        title="汇报项目"
    >
        <div class="container">
            <div class="formCont">
                <el-row>
                    <el-col :span="12">
                        <div class="label">项目名称：</div>
                        <div class="content">
                            <span
                                :class="[
                                    msg.priority == 1
                                        ? 'red'
                                        : msg.priority == 2
                                        ? 'orange'
                                        : msg.priority == 3
                                        ? 'yellow'
                                        : msg.priority == 4
                                        ? 'green'
                                        : '',
                                ]"
                            >
                                <i class="el-icon-s-flag"></i>
                                {{ msg.priority }}
                            </span>
                            <span style="margin-left: 12px">
                                {{
                                msg.name
                                }}
                            </span>
                        </div>
                    </el-col>
                    <el-col :span="12" style="position: relative">
                        <div class="charts">
                            <div class="echart-wrap">
                                <v-chart
                                    :auto-resize="true"
                                    :options="barOption"
                                    ref="eleBar"
                                    theme="ovilia-green"
                                />
                            </div>
                            <div class="echart-wrap">
                                <v-chart
                                    :auto-resize="true"
                                    :options="pieOption"
                                    ref="elePie"
                                    theme="ovilia-green"
                                />
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12" v-if="msg.type == 1">
                        <div class="label">计划日期：</div>
                        <div class="content">{{ msg.start_date }} 至 {{ msg.end_date }}</div>
                    </el-col>
                    <el-col :span="12" v-else>
                        <div class="label">开始日期：</div>
                        <div class="content">{{ msg.start_date }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <div class="label">团队成员：</div>
                        <div class="content">{{ msg.team }}</div>
                    </el-col>
                </el-row>
            </div>
            <el-form ref="reportForm" :rules="rules" :model="reportForm" label-width="110px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="项目进度" size="small" prop="progress">
                            <el-input
                                clearable
                                placeholder="请输入项目进度"
                                :max="100"
                                size="small"
                                v-model="reportForm.progress"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="项目汇报" size="small" prop="content">
                            <vue-tinymce
                                v-if="reportVisible"
                                v-model="reportForm.content"
                                :setting="setting"
                            />
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save">保存</el-button>
            <el-button size="small" @click="reportVisible = false">关闭</el-button>
        </span>
    </el-dialog>
</template>

<script>
import "echarts/lib/chart/bar";
import "echarts/lib/chart/pie";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import * as oaApi from "@/http/oaApi.js";
import { mapState } from "vuex";
export default {
    data() {
        var validateProgress = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入项目进度"));
            } else if (value == 0) {
                callback(new Error("项目进度不能为0"));
            } else if (value > 100) {
                callback(new Error("项目进度不能大于100"));
            } else {
                callback();
            }
        };
        return {
            reportForm: {
                progress: "",
                content: ""
            },
            msg: {},
            rules: {
                progress: [
                    /* {
                        required: true,
                        message: "请输入项目进度",
                        trigger: "blur"
                    } */
                    { required: true, validator: validateProgress, trigger: 'blur' }
                ]
            },
            xAxis: ["未开始", "进行中", "已完成", "已结束"],
            yAxis: [],
            max: 15
        };
    },
    props: {
        reportVisible: Boolean,
        tableItem: Object
    },
    methods: {
        save() {
            this.$refs["reportForm"].validate(valid => {
                if (valid) {
                    let params = {
                        project_id: this.tableItem.id,
                        progress: this.reportForm.progress,
                        content: this.reportForm.content,
                        not_start: this.msg.not_start,
                        in_progress: this.msg.in_progress,
                        finish_num: this.msg.finish_num,
                        close_num:this.msg.close_num
                    };
                    oaApi.projectMilestone(params, "post").then(res => {
                        //console.log(res);
                        if (res.code == 200) {
                            this.$message.success("汇报成功!");
                            this.closeDialog();
                            this.$parent.project();
                        }
                    });
                }
            });
        },
        projectReport() {
            oaApi
                .projectReport({ project_id: this.tableItem.id }, "get")
                .then(res => {
                    //console.log(res);
                    this.msg = res.data;
                    let { not_start, in_progress, finish_num, close_num } = res.data;
                    this.yAxis = [not_start, in_progress, finish_num, close_num];
                });
        },
        /**
         * 关闭对话框
         */
        closeDialog() {
            this.$emit("update:reportVisible", false);
            this.$refs["reportForm"].resetFields();
            this.$refs["reportForm"].clearValidate();
        },
        progressBlur() {
            if (
                this.reportForm.progress != "" &&
                this.reportForm.progress != 0
            ) {
                console.log(this.reportForm.progress);
            } else {
                this.reportForm.progress = "";
            }
        }
    },
    watch: {
        reportVisible: {
            handler(newValue) {
                if (newValue) {
                    this.projectReport();
                }
            }
        }
    },
    computed: {
        ...mapState({
            setting: state => state.index.setting
        }),
        barOption() {
            const options = {
                grid: {
                    left: "5%",
                    right: "5%",
                    bottom: "5%",
                    top: "15%",
                    containLabel: true
                },
                tooltip: {
                    trigger: "axis"
                },
                color: ["#eb5202"],
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        name: "公司",
                        data: this.xAxis,
                        axisTick: false,
                        axisLine: {
                            lineStyle: {
                                color: "#f4f4f4"
                            }
                        },
                        axisLabel: {
                            color: "#bcbccf"
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        // name: "（个）",
                        axisLine: false,
                        splitLine: false
                    }
                ],
                series: [
                    {
                        name: "项目状态",
                        type: "bar",
                        barWidth: "10",
                        data: this.yAxis,
                        itemStyle: {
                            normal: {
                                label: {
                                    show: true, //开启显示
                                    position: "top", //在上方显示
                                    textStyle: {
                                        //数值样式
                                        color: "black",
                                        fontSize: 15,
                                        fontWeight: 600
                                    }
                                },
                                barBorderRadius: [5, 5, 0, 0]
                            }
                        }
                    }
                ]
            };
            return options;
        },
        pieOption() {
            const handred = 100;
            // let point = 66;
            const options = {
                title: {
                    x: "center",
                    y: "32%",
                    subtext: this.msg.progress + "%",
                    itemGap: 15,
                    subtextStyle: {
                        fontWeight: "bold",
                        color: "#000000",
                        fontSize: "23"
                    },
                    text: "总进度",
                    textStyle: {
                        color: "#bcbccf",
                        fontSize: "12"
                    }
                },
                series: [
                    {
                        name: "circle",
                        type: "pie",
                        clockWise: true,
                        radius: ["65%", "80%"],
                        itemStyle: {
                            normal: {
                                label: {
                                    show: false
                                },
                                labelLine: {
                                    show: false
                                }
                            }
                        },
                        hoverAnimation: false,
                        data: [
                            {
                                value: this.msg.progress || 0,
                                name: "已完成",
                                itemStyle: {
                                    normal: {
                                        color: "#ff5a02",
                                        label: {
                                            show: false
                                        },
                                        labelLine: {
                                            show: false
                                        }
                                    }
                                }
                            },
                            {
                                name: "总进度",
                                value: handred - this.msg.progress || 0,
                                itemStyle: {
                                    normal: {
                                        color: "#E1E8EE"
                                    }
                                }
                            }
                        ]
                    }
                ]
            };
            return options;
        }
    }
};
</script>

<style lang="scss" scoped>
.report {
    .el-dialog__body {
        padding: 20px 40px;
    }
    .el-select,
    .el-date-editor {
        width: 100%;
    }
    .el-form-item {
        .el-form-item__content {
            .el-radio {
                margin: 0;
                width: 100px;
            }
        }
    }
    .container {
        margin-top: 10px;
        .formCont {
            padding: 13px 0;
            .el-row {
                margin-bottom: 10px;
                .el-col {
                    display: flex;
                    min-height: 30px;
                    align-content: center;
                    justify-content: center;
                    font-size: 13px;
                    line-height: 2;
                    .label {
                        font-size: 12px;
                        width: 120px;
                        text-align: right;
                    }
                    .content {
                        width: 100%;
                        width: calc(100% - 120px);
                        text-align: left;
                    }
                    .link {
                        color: $theme-color;
                        text-decoration: underline;
                        cursor: pointer;
                        user-select: none;
                        &:hover {
                            opacity: 0.6;
                        }
                        &:active {
                            opacity: 0.8;
                        }
                    }
                    .charts {
                        position: absolute;
                        display: flex;
                        width: 100%;
                        top: -12px;
                        .echart-wrap {
                            width: 50%;
                            margin-top: 20px;
                            .echarts {
                                width: 100%;
                                height: 150px;
                            }
                        }
                    }
                    .comment-list {
                        padding-left: 50px;
                        text-align: left;
                        width: 100%;
                        margin-bottom: 10px;
                        .cl-title {
                            padding-left: 10px;
                        }
                        .cl-content {
                            background: #f9f9f9;
                            border: 1px solid #eeeeee;
                            border-radius: 2px;
                            padding: 2px 10px;
                        }
                    }
                }
                .el-col-24 {
                    justify-content: flex-start;
                    align-content: center;
                    .label {
                        width: 120px;
                    }
                    .content {
                        width: 100%;
                        width: calc(100% - 120px);
                        text-align: left;
                    }
                }
                // border-bottom: 1px #e8e8e8 solid;
                .el-image {
                    width: 120px;
                }
            }
        }
    }
}
</style>
